import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import AboutAnimatedIcons from './AboutAnimatedIcons';
import { getDocOnce } from '../utils/firestoreOnce';

function AboutUs() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const lang = isArabic ? 'ar' : 'en';

  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getDocOnce('homePage/content')
      .then((snap) => {
        if (cancelled) return;
        if (snap.exists() && snap.data().about) setAboutData(snap.data().about);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const title = aboutData?.title?.[lang] || t('about.title');
  const subtitle = aboutData?.subtitle?.[lang] || t('about.subtitle');
  const description1 = aboutData?.description1?.[lang] || t('about.description1');
  const description2 = aboutData?.description2?.[lang] || t('about.description2');

  return (
    <section id="about" className="bg-transparent py-0 relative z-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-16 lg:gap-24" dir={isArabic ? 'rtl' : 'ltr'}>

          {/* Text Content */}
          <div className="flex-1 text-start space-y-8 py-10 md:py-20 lg:py-24">
            <div className="space-y-2">
              <p className="text-xl md:text-2xl font-medium text-gray-500 dark:text-gray-400">
                {title}
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 dark:text-white leading-[1.3] tracking-tight">
                <span className="inline-block">{subtitle.split(' ').slice(0, -1).join(' ')}</span>
                {' '}
                <span className="inline-block text-primary dark:text-[#FAA617]">{subtitle.split(' ').slice(-1).join(' ')}</span>
              </h2>
            </div>

            <div className="space-y-4">
              <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400 leading-relaxed text-justify [text-align-last:start]">
                {description1} {description2}
              </p>
            </div>

            <div className="pt-4">
              <Link
                to="/about"
                className="px-8 py-3.5 text-lg font-bold text-white bg-primary dark:bg-[#0D6EFD] rounded-xl hover:bg-primary-light dark:hover:bg-blue-600 transition-all duration-300 inline-block shadow-lg dark:shadow-[0_4px_20px_rgba(13,110,253,0.3)] hover:-translate-y-1"
              >
                {isArabic ? "المزيد عنا" : "More About Us"}
              </Link>
            </div>
          </div>

          {/* Animated Icons */}
          <div className="flex-1 flex justify-center items-center">
            <AboutAnimatedIcons />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
